export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40125157d261076fa08653754ba319fec00cb20471&name=revalidateCommunity!'